import { AccountState } from './types'
import Course from '@/store/models/course'
import Content from '@/store/models/content'

export const LOGIN = (state: AccountState, payload: {
    token: string;
    email: string;
  }) => {
  state.loggedIn = true
  state.token = payload.token
  state.email = payload.email
}

export const LOGOUT = (state: AccountState) => {
  state.loggedIn = false
  state.firstName = ''
  state.token = ''
}

export const SET_USER_INFO = (state: AccountState, payload: {
  firstName: string;
  grade: { grade: string; year: string };
  year: string;
  courses: Course[];
  selectedBooks: { [courseId: number]: number };
  }) => {
  state.firstName = payload.firstName
  state.grade = payload.grade.grade
  state.year = payload.grade.year
  state.courses = payload.courses
  state.selectedBooks = payload.selectedBooks
}

export const SET_FAVORITES = (state: AccountState, payload: Content[]) => {
  state.favorites = payload
}

export const ADD_FAVORITE = (state: AccountState, payload: Content) => {
  state.favorites.push(payload)
}

export const REMOVE_FAVORITE = (state: AccountState, id: number) => {
  state.favorites = state.favorites.filter((favorite) => favorite.user_id !== id)
}
